document.addEventListener("DOMContentLoaded", function () {
  console.log("Script SwarnaArt dimuat.");

  // ==============================
  // 1. Smooth Scroll + Tutup Menu Mobile
  // ==============================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });

        // Tutup menu mobile jika terbuka
        const navMenu = document.querySelector('.nav-menu');
        const navToggle = document.querySelector('.nav-toggle');
        if (navMenu?.classList.contains('active')) {
          navMenu.classList.remove('active');
          navToggle?.classList.remove('active');
        }
      }
    });
  });

  // ==============================
  // 2. Toggle Navigasi Mobile
  // ==============================
  const navToggle = document.querySelector('.nav-toggle');
  const navMenu = document.querySelector('.nav-menu');

  if (navToggle && navMenu) {
    navToggle.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      navToggle.classList.toggle('active');
    });

    // Tutup menu saat klik link
    document.querySelectorAll('.nav-list a').forEach(link => {
      link.addEventListener('click', () => {
        navMenu.classList.remove('active');
        navToggle.classList.remove('active');
      });
    });
  }

  // ==============================
  // 3. Testimonials Slider
  // ==============================
  const testimonialsTrack = document.getElementById('testimonialsTrack');
  if (testimonialsTrack) {
    const cards = Array.from(testimonialsTrack.querySelectorAll('.testimonial-card:not(.clone)'));
    const totalCards = cards.length;
    let currentIndex = 0;
    const cardWidth = cards[0].offsetWidth + 30;

    function updateSlider() {
      const offset = -currentIndex * cardWidth;
      testimonialsTrack.style.transform = `translateX(${offset}px)`;
    }

    const leftArrow = document.querySelector('.testimonials-section .left-arrow');
    const rightArrow = document.querySelector('.testimonials-section .right-arrow');

    rightArrow?.addEventListener('click', () => {
      if (currentIndex < totalCards + 1) {
        currentIndex++;
        updateSlider();
        if (currentIndex === totalCards) {
          setTimeout(() => {
            testimonialsTrack.style.transition = 'none';
            currentIndex = 0;
            updateSlider();
            setTimeout(() => testimonialsTrack.style.transition = 'transform 0.3s ease-in-out', 10);
          }, 300);
        }
      }
    });

    leftArrow?.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      } else {
        testimonialsTrack.style.transition = 'none';
        currentIndex = totalCards;
        updateSlider();
        setTimeout(() => {
          testimonialsTrack.style.transition = 'transform 0.3s ease-in-out';
          currentIndex = totalCards - 1;
          updateSlider();
        }, 10);
      }
    });
  }

  // ==============================
  // 4. Client Gallery Slider
  // ==============================
  const clientLogosTrack = document.getElementById('clientLogosTrack');
  if (clientLogosTrack) {
    const originalItems = Array.from(clientLogosTrack.querySelectorAll('.client-item:not(.clone)'));
    const totalOriginal = originalItems.length;
    let currentIndex = 0;
    const itemWidth = originalItems[0].offsetWidth + 40;

    function updateSlider() {
      const offset = -currentIndex * itemWidth;
      clientLogosTrack.style.transform = `translateX(${offset}px)`;
    }

    const leftArrow = document.querySelector('.clients-section .left-arrow');
    const rightArrow = document.querySelector('.clients-section .right-arrow');

    rightArrow?.addEventListener('click', () => {
      if (currentIndex < totalOriginal + 1) {
        currentIndex++;
        updateSlider();
        if (currentIndex === totalOriginal) {
          setTimeout(() => {
            clientLogosTrack.style.transition = 'none';
            currentIndex = 0;
            updateSlider();
            setTimeout(() => clientLogosTrack.style.transition = 'transform 0.3s ease-in-out', 10);
          }, 300);
        }
      }
    });

    leftArrow?.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      } else {
        clientLogosTrack.style.transition = 'none';
        currentIndex = totalOriginal;
        updateSlider();
        setTimeout(() => {
          clientLogosTrack.style.transition = 'transform 0.3s ease-in-out';
          currentIndex = totalOriginal - 1;
          updateSlider();
        }, 10);
      }
    });
  }

  // ==============================
  // 5. Animasi Saat Scroll
  // ==============================
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.section').forEach(el => {
    observer.observe(el);
  });
});

// ==============================
// 6. HERO BACKGROUND SLIDER (di luar DOMContentLoaded agar tetap jalan)
// ==============================
(function () {
  if (typeof document === 'undefined') return;

  function initHeroSlider() {
    const slides = document.querySelectorAll('.hero-slide');
    if (slides.length === 0) return;

    let currentIndex = 0;

    function showNextSlide() {
      slides.forEach(slide => slide.classList.remove('active'));
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('active');
    }

    slides[0].classList.add('active');
    setInterval(showNextSlide, 1000); // Ganti tiap 1 detik
  }

  // Jalankan saat DOM siap
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSlider);
  } else {
    initHeroSlider();
  }
})();